import {
  RelationshipsApi,
  CreateRelationshipRequest,
  UpdateRelationshipRequest,
  RelationshipResponse,
  RelationshipListResponse,
  RelationshipType
} from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

/**
 * Wrapped relationships API with standardized error handling
 */
class WrappedRelationshipsApi {
  /**
   * Create a new relationship between family members
   */
  async createRelationship(request: CreateRelationshipRequest): Promise<ApiResult<RelationshipResponse>> {
    return withApiSetup(
      (config) => new RelationshipsApi(config),
      getApiConfiguration,
      (api) => api.createRelationship(request)
    );
  }

  /**
   * Update an existing relationship
   */
  async updateRelationship(
    relationshipId: string,
    request: UpdateRelationshipRequest
  ): Promise<ApiResult<RelationshipResponse>> {
    return withApiSetup(
      (config) => new RelationshipsApi(config),
      getApiConfiguration,
      (api) => api.updateRelationship(relationshipId, request)
    );
  }

  /**
   * Delete a relationship
   */
  async deleteRelationship(relationshipId: string): Promise<ApiResult<void>> {
    return withApiSetup(
      (config) => new RelationshipsApi(config),
      getApiConfiguration,
      (api) => api.deleteRelationship(relationshipId)
    );
  }

  /**
   * Search relationships in a family with optional filters
   */
  async searchRelationships(
    familyId: string,
    familyMemberId?: string,
    relationshipType?: RelationshipType,
    page?: number,
    pageSize?: number
  ): Promise<ApiResult<RelationshipListResponse>> {
    return withApiSetup(
      (config) => new RelationshipsApi(config),
      getApiConfiguration,
      (api) => api.searchRelationships(familyId, familyMemberId, relationshipType, page, pageSize)
    );
  }
}

/**
 * Wrapped relationships API instance
 */
export const relationshipsApi = new WrappedRelationshipsApi();

export default relationshipsApi;
